<template>

  <div class="admin-body">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客服消息</el-breadcrumb-item>
        <el-breadcrumb-item>消息列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row class="hdss">
      <el-date-picker v-model="value1" style="width: 400px;" type="daterange" range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" @change="rqCk">
      </el-date-picker>
      <el-row style="margin-left: 20px; display: flex;align-items: center;">
        <el-input placeholder="请输入内容" v-model="input3" class="input-with-select">
          <el-button @click="Cx()" slot="append" icon="el-icon-search">开始查询</el-button>
        </el-input>

      </el-row>
      <el-row style="position: absolute; right: 60px;top: 20px; height: ;">
        <div @click="dialogVisible = true" style="padding: 10px 20px; background-color: rgba(28, 158, 251, 1); border-radius: 5px; color: #ffffff; cursor: pointer; font-size: 12px;">消息群发</div>
      </el-row>
    </el-row>

    <el-row v-for="(item,index) in Datalist" :key="index">
      <div class="hdss1" @click="ToXq1(item.user_id)">
        <img :src="item.image_url? 'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/' + item.image_url : '../../assets/txpp.png'" style="width: 40px; height: 40px;" alt="">
        <el-row style="text-align: left; margin-left: 20px;font-size: 14px;">
          <el-row style="color: rgba(68, 98, 133, 1); font-weight: 600;">{{item.name}}</el-row>
          <el-row style="margin: 10px 0;">{{item.content}}</el-row>
          <el-row style="color: rgba(0, 0, 0, 0.4);">{{item.creat_time}}</el-row>
        </el-row>
        <img src="../../assets/rt1.png" style="position: absolute; right: 20px; top: 50%; transform: translateY(-50%);" alt="">
      </div>

    </el-row>
    <el-row style="text-align: right; padding-bottom: 20px;">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="10" @current-change="CK">
      </el-pagination>
    </el-row>




    <el-dialog title="群发" :modal="false" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-row style="margin: 20px 0;">需要加音频（内容在60秒以内的提示）,可加广告(图片和链接).</el-row>
      <!-- <el-row class="txt">
        <el-row style="width: 20%;"> 问题：</el-row>
        <el-input v-model="input" placeholder="请输入内容"></el-input>
      </el-row> -->
      <el-row class="txt">
        <el-row style="width: 20%;">音频：</el-row>
        <el-row style="text-align: left;">
          <el-upload id="audioUpload" class="avatar-uploader" name='voice' :headers="header" :action="upLoadAudio"
            :show-file-list="true" :multiple="false" :file-list="fileList" :on-remove="handleRemove" :limit="1"
            :auto-upload="true" :on-change="handleChangeAudio" :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip" style="margin-bottom: 10px">
              只能上传mp3文件，且不超过2M，播放长度不超过60s
            </div>
          </el-upload>
          <!-- <el-upload class="upload-demo" action=" http://api.txcsok.com/AutoNews/addAutoNews"
            :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1"
            :on-exceed="handleExceed" :file-list="fileList" :auto-upload="false">
            <img src="../../assets/addNew.png" style="width: 44px; height: 44px;" alt="">

          </el-upload> -->
        </el-row>
      </el-row>
      <el-row class="txt">
        <el-row style="width: 20%;"> 文字：</el-row>
        <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="textarea">
        </el-input>
      </el-row>
      <el-row class="txt">
        <el-row style="width: 20%;"> 图片：</el-row>
        <el-row style="text-align: left;">
          <el-upload class="upload-demo" action="http://api.txcsok.com/AutoNews/addImg" name='image' :headers="header"
            :on-preview="handlePreview" :on-remove="handleRemove1" :before-remove="beforeRemove" multiple :limit="1"
            :on-exceed="handleExceed" :file-list="fileList1" :on-success="successimg" :before-upload="beforeImgUpload">
            <img src="../../assets/addNew.png" style="width: 44px; height: 44px;" alt="">
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>

          </el-upload>
        </el-row>
      </el-row>
      <el-row class="txt">
        <el-row style="width: 20%;"> 链接：</el-row>
        <el-input v-model="input4" placeholder="请输入内容"></el-input>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addNew()">确 定</el-button>
      </span>

    </el-dialog>

  </div>
</template>

<script>
  export default {
    name: "User",
    mounted() {

    },
    data() {
      return {
        dialogVisible: false,
        input: '',
        value1: '',
        input3: '',
        input4: '',
        select: '',
        Datalist: [],
        data: [],
        Getpos: {
          keyword: '',
          star_time: '',
          end_time: '',
          page: '',
          pageSize: 10
        },
        total: 0,
        header: {
          'fs-token': ''
        },
        upLoadAudio: 'http://api.txcsok.com/AutoNews/addVoice',
        fileList: [],
        textarea: '',
        fileList1: [],
        image: '',
        voice: '',
        vdioSj:0
      }
    },
    computed: {

    },
    mounted() {
      this.header = {
        'fs-token': this.$store.state.login.user.jwt
      }
      this.Getlist()
    },
    watch: {},
    methods: {
      getTimes(file) {
        var content = file;
        //获取录音时长
        var url = URL.createObjectURL(content);
        //经测试，发现audio也可获取视频的时长
        var audioElement = new Audio(url);

        audioElement.addEventListener("loadedmetadata", (_event) => {
          this.audioDuration = parseInt(audioElement.duration);
          console.log(this.audioDuration, '！！！！！！！！');
          this.vdioSj = audioDuration
        });
      },
      addNew() {
        let _this = this
        // if (this.input == '') {
        //   this.$message({
        //     message: '请填写关键字',
        //     type: 'warning'
        //   });
        //   return
        // }
        let obj = {
          // keyword: this.input,
          image: this.image,
          voice: this.voice,
          link: this.input4,
          text: this.textarea,
          voice_time:this.vdioSj
        }
        _this.$http.post(global.posturl.host + '/AutoNews/massNews', obj).then(function(response) {
          _this.dialogVisible = false
          _this.image = ''
          _this.voice = ''
          _this.input4 = ''
          _this.textarea = ''
          _this.fileList = []
          _this.fileList1 = []
          _this.Getlist()
          console.log(response.data)
        }).catch(function(error) {
          console.log(error)
        });
        // if (this.Newtype == 0) {
        //   _this.$http.post(global.posturl.host + '/AutoNews/addAutoNews', obj).then(function(response) {
        //     _this.dialogVisible = false
        //     _this.Getlist()
        //     console.log(response.data)
        //   }).catch(function(error) {
        //     console.log(error)
        //   });
        // } else {
        //   obj.new_id = _this.new_id
        //   _this.$http.post(global.posturl.host + '/AutoNews/editAutoNews', obj).then(function(response) {
        //     _this.dialogVisible = false
        //     _this.Getlist()
        //     console.log(response.data)
        //   }).catch(function(error) {
        //     console.log(error)
        //   });
        // }


      },
      beforeImgUpload() {

      },
      successimg(e) {
        console.log(e);
        this.image = e.url
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      handleRemove1(file, fileList) {
        console.log(file, fileList);
      },
      beforeAvatarUpload(file) {
        // 文件类型进行判断
        const isAudio = file.type === "audio/mp3" || file.type === "audio/mpeg";
        // 限制上传文件大小 2M
        const isLt2M = file.size / 1024 / 1024 < 2;
        this.getTimes(file);
        const isTime60S = this.audioDuration <= 60 ? true : '';
        // 获取时长
        console.log(this.audioDuration, '时间');

        if (!isAudio) {
          this.$message.error("上传文件只能是Mp3格式!");
          this.fileList = [];
        } else {
          if (!isLt2M) {
            this.$message.error("上传文件大小不能超过 2MB!");
            this.fileList = [];
          } else {
            if (!isTime60S) {
              this.$message.error("上传文件时长不能超过60秒!");
              this.fileList = [];
            }
          }
        }
        return isAudio && isLt2M && isTime60S
      },
      handleAvatarSuccess(e) {
        console.log(e, '成功');
        this.voice = e.url
      },
      handleChangeAudio(e) {
        console.log(e, '变化');
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      ToXq1(id) {
        console.log('跳转！！！！！！！！！！！！');
        this.$router.push({
          name: 'GzhXq',
          params: {
            user_id: id
          }
        })
      },
      filterTime(time) {
        var date = new Date(time);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        minute = minute < 10 ? "0" + minute : minute;
        var s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + m + "-" + d
        // + " " + h + ":" + minute + ":" + s;
      },
      rqCk(e) {
        console.log(e);
        if (e) {
          this.Getpos.star_time = this.filterTime(e[0])
          this.Getpos.end_time = this.filterTime(e[1])

        } else {
          this.Getpos.star_time = ''
          this.Getpos.end_time = ''
        }
        this.Getlist()
      },
      Getlist() {
        let _this = this
        this.$http.post(global.posturl.host + '/AutoNews/newsList', this.Getpos).then(function(response) {
          console.log(response.data, '成功')
          _this.Datalist = response.data.data
          _this.total = response.data.total
          if (response.data.code == '1') {
            // this.Datalist = response.data.data
          }
        }).catch(function(error) {
          console.log(error)
        });
      },
      Cx() {
        console.log('kais ');
        this.Getpos.keyword = this.input3
        this.Getlist()
      },
      CK(e) {
        console.log(e);
        this.Getpos.page = e
        this.Getlist()
      }
    }
  }
</script>

<style scoped>
  .admin-body {
    /*background-color: white;*/
    width: 100%;
  }

  .txt {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    text-align: left;
  }

  .main {
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }

  .block {
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .hdss {
    /* width: 1576px; */
    height: 82px;
    background-color: #ffffff;
    margin: 17px 34px;
    padding: 0px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .hdss1 {
    /* width: 1576px; */
    height: 142px;
    background-color: #ffffff;
    margin: 10px 34px;
    padding: 30px 30px;
    box-sizing: border-box;
    display: flex;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/page/user/Gzh.vue